import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Tooltip } from 'react-tippy';
import css from './QuestionMark.css';
import withTranslate from '../../containers/widgets/withTranslate';
import Icon, { IconSizes, IconTypes, IconVariants } from '../foundations/Icon';

const QuestionMark = ({
    message = '',
    translate = () => {},
    contentStyle = {},
    containerClassName = '',
    iconClassName = '',
    interactive = false,
    tooltipClassName = '',
    iconVariant = IconVariants.LIGHT,
    iconSize = IconSizes.X_SMALL,
}) => {
    const getMessage = () => {
        if (typeof message === 'string') {
            return translate(message);
        }
        return message;
    };

    return (
        <Tooltip
            html={<div style={contentStyle}>{getMessage()}</div>}
            position="top"
            inertia
            className={tooltipClassName}
            interactive={interactive}
            theme="light"
            size="big"
            popperOptions={{
                modifiers: {
                    preventOverflow: {
                        enabled: false,
                    },
                    hide: {
                        enabled: false,
                    },
                },
            }}
        >
            <span className={classNames(css.questionMarkContainer, containerClassName)}>
                <Icon
                    type={IconTypes.MINGCUTE}
                    name="question-line"
                    size={iconSize}
                    variant={iconVariant}
                    className={iconClassName}
                />
            </span>
        </Tooltip>
    );
};

QuestionMark.propTypes = {
    message: PropTypes.string,
    contentStyle: PropTypes.objectOf(PropTypes.any),
    translate: PropTypes.func,
    // https://github.com/tvkhoa/react-tippy:
    // Makes a tooltip interactive, i.e. will not close when the user hovers over or clicks on the tooltip.
    // This lets you create a popover (similar to Bootstrap) when used in conjunction with a click trigger.
    interactive: PropTypes.bool,
    iconClassName: PropTypes.string,
    containerClassName: PropTypes.string,
    tooltipClassName: PropTypes.string,
    iconVariant: PropTypes.string,
    iconSize: PropTypes.string,
};

export default memo(withTranslate(QuestionMark));
